import { QuestionConfig } from './../models/config.model';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewEncapsulation } from "@angular/core";


@Component({
    selector: 'app-question-card',
    templateUrl: './question-card.component.html',
    // styleUrls: ['./question-card.component.scss']
    encapsulation: ViewEncapsulation.None
})
export class QuestionCardComponent implements OnChanges {
    @Input() dir: 'ltr'| 'rtl';
    @Input() selectedId: string;
    @Input() question: QuestionConfig;
    @Output() selectQuestion = new EventEmitter();

    constructor() { }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.question?.currentValue)
            this.question = changes.question.currentValue;
    }

    onSelectQuestion() {
        this.selectQuestion.emit();
    }

    get hitIcons() {
        const rawResult = [];
        if (this.question.hasNotes) rawResult.push(`<i class="far fa-comment"></i>`);
        if (this.question.hasLink) rawResult.push(`<i class="fas fa-globe"></i>`);
        if (this.question.hasAttachments) rawResult.push(`<i class="fas fa-paperclip"></i>`);
        if (this.question.hasPledgeAndAcknowledgment) rawResult.push(`<i class="fas fa-check-square"></i>`);
        if (this.question.isRequired) rawResult.push(`<i class="required">*</i>`);
        return rawResult.join(' | ');
    }
}